window.initMap = () => {
  const event = new CustomEvent('google-maps:init')
  window.dispatchEvent(event)
}
